export const StickerCategories = [
	{
		id: 11864,
		name: "Quỳnh Aka Đón Tết",
		desc: "",
		totalImage: 10,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/3/a/9/0/1/11864/icon/akazalopay_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/3/a/9/0/1/11864/icon_pre/akazalopay_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 2,
		thumbImg: "https://zalo-api.zadn.vn/3/a/9/0/1/11864/preview/240x240.png",
		source: "",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 5,
		order: 0,
		stickers: [
			{
				id: 44731,
				cateId: 11864,
				type: 7,
				text: "[^11864.44731^]",
				uri: "44731",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44731&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44731&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "7bc96d009fd0618eb2662fb5971340d0",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44732,
				cateId: 11864,
				type: 7,
				text: "[^11864.44732^]",
				uri: "44732",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44732&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44732&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "b91a9d4dc1f3d51f12c39e7a2331d509",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44733,
				cateId: 11864,
				type: 7,
				text: "[^11864.44733^]",
				uri: "44733",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44733&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44733&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "39e20f811af63e7d50e15e4ca22bacd4",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44734,
				cateId: 11864,
				type: 7,
				text: "[^11864.44734^]",
				uri: "44734",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44734&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44734&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "c45265aff967926d0601a07edcea0478",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44735,
				cateId: 11864,
				type: 7,
				text: "[^11864.44735^]",
				uri: "44735",
				fkey: 14,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44735&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44735&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "8243b123b3d1d6681f520de376bbc250",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=44735&size=130",
				},
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44736,
				cateId: 11864,
				type: 7,
				text: "[^11864.44736^]",
				uri: "44736",
				fkey: 16,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44736&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44736&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "eddc77f56bb074c5c7975448b6004120",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=44736&size=130",
				},
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44737,
				cateId: 11864,
				type: 7,
				text: "[^11864.44737^]",
				uri: "44737",
				fkey: 16,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44737&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44737&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "4fbacd72ed6a1613d90e7d30a8cdd9aa",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=44737&size=130",
				},
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44738,
				cateId: 11864,
				type: 7,
				text: "[^11864.44738^]",
				uri: "44738",
				fkey: 12,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44738&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44738&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "b437d5052877bb7e345d1708b16ea44e",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=44738&size=130",
				},
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44739,
				cateId: 11864,
				type: 7,
				text: "[^11864.44739^]",
				uri: "44739",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44739&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44739&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "0fc50471e257487edb7d6fa64caa85ec",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324232,
				updateState: 0,
			},
			{
				id: 44740,
				cateId: 11864,
				type: 7,
				text: "[^11864.44740^]",
				uri: "44740",
				fkey: 16,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=44740&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=44740&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 90,
				effectId: 0,
				checksum: "acbf4335bfa31c106c7c071e1e7000ca",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=44740&size=130",
				},
				fetchTs: 1745311324232,
				updateState: 0,
			},
		],
	},
	{
		id: 12002,
		name: "Trọc Trắng",
		desc: "",
		totalImage: 12,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/f/6/b/c/0/12002/icon/troctrang_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/f/6/b/c/0/12002/icon_pre/troctrang_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 2,
		thumbImg: "https://zalo-api.zadn.vn/f/6/b/c/0/12002/preview/440x440.png",
		source: "0",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 46952,
				cateId: 12002,
				type: 7,
				text: "[^12002.46952^]",
				uri: "46952",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46952&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46952&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46953,
				cateId: 12002,
				type: 7,
				text: "[^12002.46953^]",
				uri: "46953",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46953&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46953&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46954,
				cateId: 12002,
				type: 7,
				text: "[^12002.46954^]",
				uri: "46954",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46954&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46954&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46955,
				cateId: 12002,
				type: 7,
				text: "[^12002.46955^]",
				uri: "46955",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46955&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46955&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46956,
				cateId: 12002,
				type: 7,
				text: "[^12002.46956^]",
				uri: "46956",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46956&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46956&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46957,
				cateId: 12002,
				type: 7,
				text: "[^12002.46957^]",
				uri: "46957",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46957&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46957&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46958,
				cateId: 12002,
				type: 7,
				text: "[^12002.46958^]",
				uri: "46958",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46958&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46958&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46959,
				cateId: 12002,
				type: 7,
				text: "[^12002.46959^]",
				uri: "46959",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46959&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46959&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46960,
				cateId: 12002,
				type: 7,
				text: "[^12002.46960^]",
				uri: "46960",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46960&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46960&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46961,
				cateId: 12002,
				type: 7,
				text: "[^12002.46961^]",
				uri: "46961",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46961&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46961&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46962,
				cateId: 12002,
				type: 7,
				text: "[^12002.46962^]",
				uri: "46962",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46962&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46962&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
			{
				id: 46963,
				cateId: 12002,
				type: 7,
				text: "[^12002.46963^]",
				uri: "46963",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46963&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46963&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311427805,
				updateState: 0,
			},
		],
	},
	{
		id: 12065,
		name: "Én Comic",
		desc: "",
		totalImage: 16,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/a/1/d/4/6/12065/icon/encomic_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/a/1/d/4/6/12065/icon_pre/encomic_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 3,
		thumbImg: "https://zalo-api.zadn.vn/a/1/d/4/6/12065/preview/440 x 440.png",
		source: "Tuấn Dũng",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 47943,
				cateId: 12065,
				type: 7,
				text: "[^12065.47943^]",
				uri: "47943",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47943&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47943&size=130",
				stickerWebpUrl: null,
				totalFrames: 36,
				duration: 55,
				effectId: 0,
				checksum: "734fd331615c361865c4324f5d2f54b8",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=47943&size=130",
				},
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47944,
				cateId: 12065,
				type: 7,
				text: "[^12065.47944^]",
				uri: "47944",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47944&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47944&size=130",
				stickerWebpUrl: null,
				totalFrames: 7,
				duration: 100,
				effectId: 0,
				checksum: "c72916648c0eae2f696427634519bd20",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=47944&size=130",
				},
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47945,
				cateId: 12065,
				type: 7,
				text: "[^12065.47945^]",
				uri: "47945",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47945&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47945&size=130",
				stickerWebpUrl: null,
				totalFrames: 36,
				duration: 80,
				effectId: 0,
				checksum: "6b55efe80bd6c46aed3a7206d892bf80",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47946,
				cateId: 12065,
				type: 7,
				text: "[^12065.47946^]",
				uri: "47946",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47946&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47946&size=130",
				stickerWebpUrl: null,
				totalFrames: 36,
				duration: 70,
				effectId: 0,
				checksum: "a5efba76778443a1ba175b318c8c8a10",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=47946&size=130",
				},
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47947,
				cateId: 12065,
				type: 7,
				text: "[^12065.47947^]",
				uri: "47947",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47947&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47947&size=130",
				stickerWebpUrl: null,
				totalFrames: 21,
				duration: 80,
				effectId: 0,
				checksum: "40cc18ccf94f47401094ff1dca9f0dc7",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47948,
				cateId: 12065,
				type: 7,
				text: "[^12065.47948^]",
				uri: "47948",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47948&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47948&size=130",
				stickerWebpUrl: null,
				totalFrames: 21,
				duration: 80,
				effectId: 0,
				checksum: "7c336a24224ef6b1f4231db7aa3d783b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47949,
				cateId: 12065,
				type: 7,
				text: "[^12065.47949^]",
				uri: "47949",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47949&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47949&size=130",
				stickerWebpUrl: null,
				totalFrames: 36,
				duration: 80,
				effectId: 0,
				checksum: "d2c7369c7040f297043c0973ecf3b195",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47950,
				cateId: 12065,
				type: 7,
				text: "[^12065.47950^]",
				uri: "47950",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47950&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47950&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 80,
				effectId: 0,
				checksum: "ba19b3479df8793a9b024a1cda3e9e4d",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47951,
				cateId: 12065,
				type: 7,
				text: "[^12065.47951^]",
				uri: "47951",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47951&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47951&size=130",
				stickerWebpUrl: null,
				totalFrames: 36,
				duration: 70,
				effectId: 0,
				checksum: "85809932d47a02d911942e8be3665a3a",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=47951&size=130",
				},
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47952,
				cateId: 12065,
				type: 7,
				text: "[^12065.47952^]",
				uri: "47952",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47952&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47952&size=130",
				stickerWebpUrl: null,
				totalFrames: 24,
				duration: 70,
				effectId: 0,
				checksum: "b1e45572b86cce8a5e1f2e93456f2ead",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=47952&size=130",
				},
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47953,
				cateId: 12065,
				type: 7,
				text: "[^12065.47953^]",
				uri: "47953",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47953&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47953&size=130",
				stickerWebpUrl: null,
				totalFrames: 26,
				duration: 80,
				effectId: 0,
				checksum: "f97e4b5bf4523a873352c864fc52ee76",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47954,
				cateId: 12065,
				type: 7,
				text: "[^12065.47954^]",
				uri: "47954",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47954&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47954&size=130",
				stickerWebpUrl: null,
				totalFrames: 22,
				duration: 80,
				effectId: 0,
				checksum: "3c972a42d1dc19952b14ff57d738416b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47955,
				cateId: 12065,
				type: 7,
				text: "[^12065.47955^]",
				uri: "47955",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47955&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47955&size=130",
				stickerWebpUrl: null,
				totalFrames: 36,
				duration: 70,
				effectId: 0,
				checksum: "17cacf2135eec67e60acaf951226db34",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=47955&size=130",
				},
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47956,
				cateId: 12065,
				type: 7,
				text: "[^12065.47956^]",
				uri: "47956",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47956&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47956&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 80,
				effectId: 0,
				checksum: "9eecc8fa8d9986377f665025958416e1",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47957,
				cateId: 12065,
				type: 7,
				text: "[^12065.47957^]",
				uri: "47957",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47957&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47957&size=130",
				stickerWebpUrl: null,
				totalFrames: 36,
				duration: 80,
				effectId: 0,
				checksum: "0c760c1b7450807e4023230da92ca497",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
			{
				id: 47958,
				cateId: 12065,
				type: 7,
				text: "[^12065.47958^]",
				uri: "47958",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=47958&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=47958&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 80,
				effectId: 0,
				checksum: "f7669b41e5715645115c6b63136cbaba",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1746873774434,
				updateState: 0,
			},
		],
	},
	{
		id: 12003,
		name: "Mèo Méo Meo",
		desc: "",
		totalImage: 28,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/d/2/a/9/a/12003/icon/meomeomeo_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/d/2/a/9/a/12003/icon_pre/meomeomeo_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 2,
		thumbImg: "https://zalo-api.zadn.vn/d/2/a/9/a/12003/preview/440x440.png",
		source: "\bTrixie",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 46964,
				cateId: 12003,
				type: 7,
				text: "[^12003.46964^]",
				uri: "46964",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46964&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46964&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46965,
				cateId: 12003,
				type: 7,
				text: "[^12003.46965^]",
				uri: "46965",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46965&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46965&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46966,
				cateId: 12003,
				type: 7,
				text: "[^12003.46966^]",
				uri: "46966",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46966&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46966&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46967,
				cateId: 12003,
				type: 7,
				text: "[^12003.46967^]",
				uri: "46967",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46967&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46967&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46968,
				cateId: 12003,
				type: 7,
				text: "[^12003.46968^]",
				uri: "46968",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46968&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46968&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46969,
				cateId: 12003,
				type: 7,
				text: "[^12003.46969^]",
				uri: "46969",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46969&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46969&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46970,
				cateId: 12003,
				type: 7,
				text: "[^12003.46970^]",
				uri: "46970",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46970&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46970&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46971,
				cateId: 12003,
				type: 7,
				text: "[^12003.46971^]",
				uri: "46971",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46971&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46971&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46972,
				cateId: 12003,
				type: 7,
				text: "[^12003.46972^]",
				uri: "46972",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46972&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46972&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46973,
				cateId: 12003,
				type: 7,
				text: "[^12003.46973^]",
				uri: "46973",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46973&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46973&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46974,
				cateId: 12003,
				type: 7,
				text: "[^12003.46974^]",
				uri: "46974",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46974&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46974&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46975,
				cateId: 12003,
				type: 7,
				text: "[^12003.46975^]",
				uri: "46975",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46975&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46975&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46976,
				cateId: 12003,
				type: 7,
				text: "[^12003.46976^]",
				uri: "46976",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46976&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46976&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46977,
				cateId: 12003,
				type: 7,
				text: "[^12003.46977^]",
				uri: "46977",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46977&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46977&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46978,
				cateId: 12003,
				type: 7,
				text: "[^12003.46978^]",
				uri: "46978",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46978&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46978&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46979,
				cateId: 12003,
				type: 7,
				text: "[^12003.46979^]",
				uri: "46979",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46979&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46979&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46980,
				cateId: 12003,
				type: 7,
				text: "[^12003.46980^]",
				uri: "46980",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46980&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46980&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46981,
				cateId: 12003,
				type: 7,
				text: "[^12003.46981^]",
				uri: "46981",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46981&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46981&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46982,
				cateId: 12003,
				type: 7,
				text: "[^12003.46982^]",
				uri: "46982",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46982&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46982&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46983,
				cateId: 12003,
				type: 7,
				text: "[^12003.46983^]",
				uri: "46983",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46983&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46983&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46984,
				cateId: 12003,
				type: 7,
				text: "[^12003.46984^]",
				uri: "46984",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46984&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46984&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46985,
				cateId: 12003,
				type: 7,
				text: "[^12003.46985^]",
				uri: "46985",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46985&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46985&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46986,
				cateId: 12003,
				type: 7,
				text: "[^12003.46986^]",
				uri: "46986",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46986&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46986&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46987,
				cateId: 12003,
				type: 7,
				text: "[^12003.46987^]",
				uri: "46987",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46987&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46987&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46988,
				cateId: 12003,
				type: 7,
				text: "[^12003.46988^]",
				uri: "46988",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46988&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46988&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46989,
				cateId: 12003,
				type: 7,
				text: "[^12003.46989^]",
				uri: "46989",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46989&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46989&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46990,
				cateId: 12003,
				type: 7,
				text: "[^12003.46990^]",
				uri: "46990",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46990&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46990&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
			{
				id: 46991,
				cateId: 12003,
				type: 7,
				text: "[^12003.46991^]",
				uri: "46991",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46991&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46991&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 60,
				effectId: 0,
				checksum: null,
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311326024,
				updateState: 0,
			},
		],
	},
	{
		id: 10786,
		name: "Usagyuuun Tăng Động",
		desc: "",
		totalImage: 24,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/8/7/2/d/5/10786/icon/usa2_ic.png",
		iconPreview: "https://zalo-api.zadn.vn/8/7/2/d/5/10786/icon_pre/usa2_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 3,
		thumbImg: "https://zalo-api.zadn.vn/8/7/2/d/5/10786/preview/usa2_cover.png",
		source: "Minto Inc.",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 28360,
				cateId: 10786,
				type: 7,
				text: "[^10786.28360^]",
				uri: "28360",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28360&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28360&size=130",
				stickerWebpUrl: null,
				totalFrames: 5,
				duration: 50,
				effectId: 0,
				checksum: "d2ee7daab03ba3f5d24676cf7824f1b9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28361,
				cateId: 10786,
				type: 7,
				text: "[^10786.28361^]",
				uri: "28361",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28361&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28361&size=130",
				stickerWebpUrl: null,
				totalFrames: 17,
				duration: 50,
				effectId: 0,
				checksum: "fb55b494ff4722f7a2b9165816c89a2f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28362,
				cateId: 10786,
				type: 7,
				text: "[^10786.28362^]",
				uri: "28362",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28362&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28362&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 50,
				effectId: 0,
				checksum: "1716d57a0865a1426eba34dffaf8d6e9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28363,
				cateId: 10786,
				type: 7,
				text: "[^10786.28363^]",
				uri: "28363",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28363&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28363&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 50,
				effectId: 0,
				checksum: "7ed89fb58aa6874fede4aaeb906132aa",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28364,
				cateId: 10786,
				type: 7,
				text: "[^10786.28364^]",
				uri: "28364",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28364&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28364&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 50,
				effectId: 0,
				checksum: "8976c4c0006c1737acb4fb3e59249ac5",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28365,
				cateId: 10786,
				type: 7,
				text: "[^10786.28365^]",
				uri: "28365",
				fkey: 16,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28365&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28365&size=130",
				stickerWebpUrl: null,
				totalFrames: 17,
				duration: 50,
				effectId: 0,
				checksum: "e3ffb1a655eba7521b9359f17869dbef",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28366,
				cateId: 10786,
				type: 7,
				text: "[^10786.28366^]",
				uri: "28366",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28366&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28366&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 50,
				effectId: 0,
				checksum: "c522ae3978e295f298c9d2e9e9a33ccf",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28367,
				cateId: 10786,
				type: 7,
				text: "[^10786.28367^]",
				uri: "28367",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28367&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28367&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 50,
				effectId: 0,
				checksum: "1d4dbef211f8a146a046cea985705dfc",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28368,
				cateId: 10786,
				type: 7,
				text: "[^10786.28368^]",
				uri: "28368",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28368&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28368&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 50,
				effectId: 0,
				checksum: "6bb23989fe2ae6b2fd1dbf1b2d8f12e6",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28369,
				cateId: 10786,
				type: 7,
				text: "[^10786.28369^]",
				uri: "28369",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28369&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28369&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 50,
				effectId: 0,
				checksum: "ee660e3aa0f9b60bd8a6a400a1bb1774",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28370,
				cateId: 10786,
				type: 7,
				text: "[^10786.28370^]",
				uri: "28370",
				fkey: 17,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28370&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28370&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 50,
				effectId: 0,
				checksum: "cb81ed1ee05cb4897f1397bca0d420b1",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28371,
				cateId: 10786,
				type: 7,
				text: "[^10786.28371^]",
				uri: "28371",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28371&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28371&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 50,
				effectId: 0,
				checksum: "d0e2eb7534f39df0fce3a079a039918d",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28372,
				cateId: 10786,
				type: 7,
				text: "[^10786.28372^]",
				uri: "28372",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28372&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28372&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 50,
				effectId: 0,
				checksum: "a5675592b6ae4d16e890eab4fca7b25f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28373,
				cateId: 10786,
				type: 7,
				text: "[^10786.28373^]",
				uri: "28373",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28373&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28373&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 50,
				effectId: 0,
				checksum: "f460b5a1e191cbc0dbb021eb25fbb8a0",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28374,
				cateId: 10786,
				type: 7,
				text: "[^10786.28374^]",
				uri: "28374",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28374&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28374&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 50,
				effectId: 0,
				checksum: "1dd1c2592eb1929425622edb398781d3",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28375,
				cateId: 10786,
				type: 7,
				text: "[^10786.28375^]",
				uri: "28375",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28375&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28375&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 50,
				effectId: 0,
				checksum: "30a0f76c3b7f27cf89c4e01185331e5b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28376,
				cateId: 10786,
				type: 7,
				text: "[^10786.28376^]",
				uri: "28376",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28376&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28376&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 50,
				effectId: 0,
				checksum: "96878ca0b882dcb42248ac82b5391e50",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28377,
				cateId: 10786,
				type: 7,
				text: "[^10786.28377^]",
				uri: "28377",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28377&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28377&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 50,
				effectId: 0,
				checksum: "2bcd1389908d6cf14eed96ce931e7be1",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28378,
				cateId: 10786,
				type: 7,
				text: "[^10786.28378^]",
				uri: "28378",
				fkey: 15,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28378&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28378&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 50,
				effectId: 0,
				checksum: "d0e25c489d0c387d0610b9329ec20ba1",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28379,
				cateId: 10786,
				type: 7,
				text: "[^10786.28379^]",
				uri: "28379",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28379&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28379&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 50,
				effectId: 0,
				checksum: "bdd58b411023e126ef14b7e8cf5fb622",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28380,
				cateId: 10786,
				type: 7,
				text: "[^10786.28380^]",
				uri: "28380",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28380&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28380&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 50,
				effectId: 0,
				checksum: "3c5da3ff88c5b7d3f8fd1ba4646e0ccc",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28381,
				cateId: 10786,
				type: 7,
				text: "[^10786.28381^]",
				uri: "28381",
				fkey: 5,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28381&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28381&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 50,
				effectId: 0,
				checksum: "dee635f4464bd86b4e32ce843c326ba0",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28382,
				cateId: 10786,
				type: 7,
				text: "[^10786.28382^]",
				uri: "28382",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28382&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28382&size=130",
				stickerWebpUrl: null,
				totalFrames: 4,
				duration: 50,
				effectId: 0,
				checksum: "534a3c5862f53f0e49e58ef33f9adf1a",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
			{
				id: 28383,
				cateId: 10786,
				type: 7,
				text: "[^10786.28383^]",
				uri: "28383",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=28383&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=28383&size=130",
				stickerWebpUrl: null,
				totalFrames: 7,
				duration: 50,
				effectId: 0,
				checksum: "9cfc63a2deccfb900acbbcaa299c8420",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325525,
				updateState: 0,
			},
		],
	},
	{
		id: 10243,
		name: "Rồng Vàng Voice",
		desc: "",
		totalImage: 13,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/a/5/6/e/e/10243/icon/rongvoice_ic.png",
		iconPreview: "https://zalo-api.zadn.vn/a/5/6/e/e/10243/icon_pre/rongvoice_thumb.png",
		price: -1,
		group: 4,
		status: 0,
		version: 1,
		thumbImg: "https://zalo-api.zadn.vn/a/5/6/e/e/10243/preview/rongvoice_cover.png",
		source: "Thăng Fly Comics",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 20088,
				cateId: 10243,
				type: 8,
				text: "[^10243.20088^]",
				uri: "20088",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20088&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20088&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "a8aa46581fadeb25635f8afbaee4b6fe",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20089,
				cateId: 10243,
				type: 8,
				text: "[^10243.20089^]",
				uri: "20089",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20089&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20089&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "4f1fc24b0b97faeda108461ad2652f69",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20090,
				cateId: 10243,
				type: 8,
				text: "[^10243.20090^]",
				uri: "20090",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20090&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20090&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "84377040c690940ffc06e3da8e4910d8",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20091,
				cateId: 10243,
				type: 8,
				text: "[^10243.20091^]",
				uri: "20091",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20091&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20091&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "48f06f5ead5deada6391fd2437eecb94",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20092,
				cateId: 10243,
				type: 8,
				text: "[^10243.20092^]",
				uri: "20092",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20092&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20092&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "cc40f7178def126169c0ab6f10f34ee9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20093,
				cateId: 10243,
				type: 8,
				text: "[^10243.20093^]",
				uri: "20093",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20093&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20093&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "2a7dd29f0ba6496bba145baccd6f3ff4",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20094,
				cateId: 10243,
				type: 8,
				text: "[^10243.20094^]",
				uri: "20094",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20094&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20094&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "77f107388eab1ffee77fa5a6d4bd6a77",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20095,
				cateId: 10243,
				type: 8,
				text: "[^10243.20095^]",
				uri: "20095",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20095&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20095&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "55de5f6e587cba33bdfc2044ebe360a2",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20096,
				cateId: 10243,
				type: 8,
				text: "[^10243.20096^]",
				uri: "20096",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20096&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20096&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "648b10a2b387c32955335e9ace856175",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20097,
				cateId: 10243,
				type: 8,
				text: "[^10243.20097^]",
				uri: "20097",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20097&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20097&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "298de76bc2720f694db3e33cef75180f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20098,
				cateId: 10243,
				type: 8,
				text: "[^10243.20098^]",
				uri: "20098",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20098&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20098&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "4519f5bf58aff393d8a20e39d8a9a4ea",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20099,
				cateId: 10243,
				type: 8,
				text: "[^10243.20099^]",
				uri: "20099",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20099&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20099&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "b6658d9aa1edf9e79730796fc4a4db87",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
			{
				id: 20100,
				cateId: 10243,
				type: 8,
				text: "[^10243.20100^]",
				uri: "20100",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=20100&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=20100&size=130",
				stickerWebpUrl: null,
				totalFrames: 1,
				duration: 300,
				effectId: 0,
				checksum: "6d6e9477126d5ed3346dd9b775cc69de",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324622,
				updateState: 0,
			},
		],
	},
	{
		id: 11752,
		name: "Crazy Frog 2",
		desc: "",
		totalImage: 12,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/a/e/e/5/6/11752/icon/crazyfrog2_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/a/e/e/5/6/11752/icon_pre/crazyfrog2_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 2,
		thumbImg: "https://zalo-api.zadn.vn/a/e/e/5/6/11752/preview/240x240.png",
		source: "Nam Nguyen",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 42829,
				cateId: 11752,
				type: 7,
				text: "[^11752.42829^]",
				uri: "42829",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42829&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42829&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 110,
				effectId: 0,
				checksum: "79c7dc64a89a2f403ded6cdab0fc065f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42830,
				cateId: 11752,
				type: 7,
				text: "[^11752.42830^]",
				uri: "42830",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42830&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42830&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 110,
				effectId: 0,
				checksum: "125189ec236b5e15a3c813ab93e8d05b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42831,
				cateId: 11752,
				type: 7,
				text: "[^11752.42831^]",
				uri: "42831",
				fkey: 13,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42831&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42831&size=130",
				stickerWebpUrl: null,
				totalFrames: 13,
				duration: 110,
				effectId: 0,
				checksum: "f584ea712e4cf26576da4bb881c6e40b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=42831&size=130",
				},
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42832,
				cateId: 11752,
				type: 7,
				text: "[^11752.42832^]",
				uri: "42832",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42832&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42832&size=130",
				stickerWebpUrl: null,
				totalFrames: 3,
				duration: 110,
				effectId: 0,
				checksum: "d0b9e56fabf2019ff87dd0182b3e3737",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42833,
				cateId: 11752,
				type: 7,
				text: "[^11752.42833^]",
				uri: "42833",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42833&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42833&size=130",
				stickerWebpUrl: null,
				totalFrames: 7,
				duration: 110,
				effectId: 0,
				checksum: "75cad2e1e4173355d872d6347bbdee5b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42834,
				cateId: 11752,
				type: 7,
				text: "[^11752.42834^]",
				uri: "42834",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42834&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42834&size=130",
				stickerWebpUrl: null,
				totalFrames: 7,
				duration: 110,
				effectId: 0,
				checksum: "03b27d892eebcc7ce11a459ba1022560",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42835,
				cateId: 11752,
				type: 7,
				text: "[^11752.42835^]",
				uri: "42835",
				fkey: 10,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42835&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42835&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 110,
				effectId: 0,
				checksum: "59b0255fcd0e101b0058b7ecd4e7803d",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=42835&size=130",
				},
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42836,
				cateId: 11752,
				type: 7,
				text: "[^11752.42836^]",
				uri: "42836",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42836&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42836&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 110,
				effectId: 0,
				checksum: "4946222ea6c7e0ecbad7ae11702819ed",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42837,
				cateId: 11752,
				type: 7,
				text: "[^11752.42837^]",
				uri: "42837",
				fkey: 3,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42837&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42837&size=130",
				stickerWebpUrl: null,
				totalFrames: 3,
				duration: 110,
				effectId: 0,
				checksum: "f1e5d89e58f572c041a111b20bf0c531",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=42837&size=130",
				},
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42838,
				cateId: 11752,
				type: 7,
				text: "[^11752.42838^]",
				uri: "42838",
				fkey: 8,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42838&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42838&size=130",
				stickerWebpUrl: null,
				totalFrames: 31,
				duration: 110,
				effectId: 0,
				checksum: "fe186a939fcfbd03bcf507f5c1bb5d3d",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=42838&size=130",
				},
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42839,
				cateId: 11752,
				type: 7,
				text: "[^11752.42839^]",
				uri: "42839",
				fkey: 11,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42839&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42839&size=130",
				stickerWebpUrl: null,
				totalFrames: 13,
				duration: 110,
				effectId: 0,
				checksum: "80bec92758ab02546cf28a951ecddf62",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=42839&size=130",
				},
				fetchTs: 1745311324421,
				updateState: 0,
			},
			{
				id: 42840,
				cateId: 11752,
				type: 7,
				text: "[^11752.42840^]",
				uri: "42840",
				fkey: 5,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=42840&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=42840&size=130",
				stickerWebpUrl: null,
				totalFrames: 19,
				duration: 110,
				effectId: 0,
				checksum: "f7088c4d4eb9a85505a0acb346533915",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=42840&size=130",
				},
				fetchTs: 1745311324421,
				updateState: 0,
			},
		],
	},
	{
		id: 11945,
		name: "Hổ Mặt Mâm",
		desc: "",
		totalImage: 12,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/8/2/0/4/8/11945/icon/homatmam_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/8/2/0/4/8/11945/icon_pre/homatmam_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 4,
		thumbImg: "https://zalo-api.zadn.vn/8/2/0/4/8/11945/preview/440x440.png",
		source: "0",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 46020,
				cateId: 11945,
				type: 7,
				text: "[^11945.46020^]",
				uri: "46020",
				fkey: 3,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46020&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46020&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 75,
				effectId: 0,
				checksum: "5b5fd450bfac9f0343e0844b8f2f02a0",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46020&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46021,
				cateId: 11945,
				type: 7,
				text: "[^11945.46021^]",
				uri: "46021",
				fkey: 4,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46021&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46021&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 150,
				effectId: 0,
				checksum: "2676221459be91d93026ac70ebf53a2d",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 2,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46021&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46022,
				cateId: 11945,
				type: 7,
				text: "[^11945.46022^]",
				uri: "46022",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46022&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46022&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 120,
				effectId: 0,
				checksum: "83210a8436bf5db4dcd6b770dd82ee88",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46022&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46023,
				cateId: 11945,
				type: 7,
				text: "[^11945.46023^]",
				uri: "46023",
				fkey: 4,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46023&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46023&size=130",
				stickerWebpUrl: null,
				totalFrames: 5,
				duration: 170,
				effectId: 0,
				checksum: "ce868f265de35cb9140977e620e4950a",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46023&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46024,
				cateId: 11945,
				type: 7,
				text: "[^11945.46024^]",
				uri: "46024",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46024&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46024&size=130",
				stickerWebpUrl: null,
				totalFrames: 4,
				duration: 100,
				effectId: 0,
				checksum: "06f77e71faa87853567354a8f7897ee7",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46024&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46025,
				cateId: 11945,
				type: 7,
				text: "[^11945.46025^]",
				uri: "46025",
				fkey: 6,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46025&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46025&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 110,
				effectId: 0,
				checksum: "57ae1033a8b8c98dc0769d427468be0a",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46025&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46026,
				cateId: 11945,
				type: 7,
				text: "[^11945.46026^]",
				uri: "46026",
				fkey: 7,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46026&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46026&size=130",
				stickerWebpUrl: null,
				totalFrames: 7,
				duration: 110,
				effectId: 0,
				checksum: "681c44bfdb3e4179164ddaa0062d12d1",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46026&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46027,
				cateId: 11945,
				type: 7,
				text: "[^11945.46027^]",
				uri: "46027",
				fkey: 14,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46027&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46027&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 90,
				effectId: 0,
				checksum: "8a5dd06aeeb2193f65973bb1286c1645",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46027&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46028,
				cateId: 11945,
				type: 7,
				text: "[^11945.46028^]",
				uri: "46028",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46028&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46028&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 120,
				effectId: 0,
				checksum: "b506bfbfb5ac68e0656cbf0e0ed1cbba",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46028&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46029,
				cateId: 11945,
				type: 7,
				text: "[^11945.46029^]",
				uri: "46029",
				fkey: 5,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46029&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46029&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 150,
				effectId: 0,
				checksum: "c44e0507d5c746f52013fbda00a9fe69",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46029&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46030,
				cateId: 11945,
				type: 7,
				text: "[^11945.46030^]",
				uri: "46030",
				fkey: 5,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46030&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46030&size=130",
				stickerWebpUrl: null,
				totalFrames: 7,
				duration: 130,
				effectId: 0,
				checksum: "0ce392d1ba7d5bd1646ca1295798b4ef",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46030&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
			{
				id: 46031,
				cateId: 11945,
				type: 7,
				text: "[^11945.46031^]",
				uri: "46031",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46031&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46031&size=130",
				stickerWebpUrl: null,
				totalFrames: 4,
				duration: 130,
				effectId: 0,
				checksum: "657bf94e25965d82f469c129dfd6290c",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46031&size=130",
				},
				fetchTs: 1745311324346,
				updateState: 0,
			},
		],
	},
	{
		id: 11962,
		name: "Mimi & Neko Couple",
		desc: "",
		totalImage: 20,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/e/8/c/1/b/11962/icon/mimi&nekocouple_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/e/8/c/1/b/11962/icon_pre/mimi&nekocouple_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 2,
		thumbImg: "https://zalo-api.zadn.vn/e/8/c/1/b/11962/preview/440x440.png",
		source: "Minto Inc.",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 46320,
				cateId: 11962,
				type: 7,
				text: "[^11962.46320^]",
				uri: "46320",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46320&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46320&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "39bd1094f2d74ff3de1068dd186a1e17",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46321,
				cateId: 11962,
				type: 7,
				text: "[^11962.46321^]",
				uri: "46321",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46321&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46321&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 100,
				effectId: 0,
				checksum: "39b5833ba1a280e11d95f7727179a793",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46322,
				cateId: 11962,
				type: 7,
				text: "[^11962.46322^]",
				uri: "46322",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46322&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46322&size=130",
				stickerWebpUrl: null,
				totalFrames: 4,
				duration: 100,
				effectId: 0,
				checksum: "d57ad46e7d03f6912ada3270f2b54db8",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46323,
				cateId: 11962,
				type: 7,
				text: "[^11962.46323^]",
				uri: "46323",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46323&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46323&size=130",
				stickerWebpUrl: null,
				totalFrames: 24,
				duration: 100,
				effectId: 0,
				checksum: "b5d25c1fd41b1be2f7f53dedd256663b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46324,
				cateId: 11962,
				type: 7,
				text: "[^11962.46324^]",
				uri: "46324",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46324&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46324&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "ce9f6f2dc70ba711e24789fc8815e63f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46325,
				cateId: 11962,
				type: 7,
				text: "[^11962.46325^]",
				uri: "46325",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46325&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46325&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 100,
				effectId: 0,
				checksum: "17426c744b9aad98961f897d8cd85372",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46326,
				cateId: 11962,
				type: 7,
				text: "[^11962.46326^]",
				uri: "46326",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46326&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46326&size=130",
				stickerWebpUrl: null,
				totalFrames: 4,
				duration: 100,
				effectId: 0,
				checksum: "6e7497360323014c99eb839fd59222ed",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46327,
				cateId: 11962,
				type: 7,
				text: "[^11962.46327^]",
				uri: "46327",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46327&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46327&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 100,
				effectId: 0,
				checksum: "dd77624edde3feea6fd5a5fb44defb5b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46328,
				cateId: 11962,
				type: 7,
				text: "[^11962.46328^]",
				uri: "46328",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46328&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46328&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 100,
				effectId: 0,
				checksum: "02ee35227a8bbb9278fa0b471841c58e",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46329,
				cateId: 11962,
				type: 7,
				text: "[^11962.46329^]",
				uri: "46329",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46329&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46329&size=130",
				stickerWebpUrl: null,
				totalFrames: 17,
				duration: 100,
				effectId: 0,
				checksum: "2c202fa629274f660df3cf4f37139de9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46330,
				cateId: 11962,
				type: 7,
				text: "[^11962.46330^]",
				uri: "46330",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46330&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46330&size=130",
				stickerWebpUrl: null,
				totalFrames: 19,
				duration: 90,
				effectId: 0,
				checksum: "38c3794697cd21bf5e08c39919b6e565",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46330&size=130",
				},
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46331,
				cateId: 11962,
				type: 7,
				text: "[^11962.46331^]",
				uri: "46331",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46331&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46331&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 100,
				effectId: 0,
				checksum: "ae328380b6535bd8867a6f2045b96965",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46332,
				cateId: 11962,
				type: 7,
				text: "[^11962.46332^]",
				uri: "46332",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46332&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46332&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 100,
				effectId: 0,
				checksum: "c8ee1d84a3e516a668570ead7a607109",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46333,
				cateId: 11962,
				type: 7,
				text: "[^11962.46333^]",
				uri: "46333",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46333&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46333&size=130",
				stickerWebpUrl: null,
				totalFrames: 24,
				duration: 80,
				effectId: 0,
				checksum: "0086bdc79af15b13e9e7f91326d1d6d8",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46333&size=130",
				},
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46334,
				cateId: 11962,
				type: 7,
				text: "[^11962.46334^]",
				uri: "46334",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46334&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46334&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "0941823924ef72618179bd9a8a9bf2e3",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46335,
				cateId: 11962,
				type: 7,
				text: "[^11962.46335^]",
				uri: "46335",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46335&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46335&size=130",
				stickerWebpUrl: null,
				totalFrames: 24,
				duration: 90,
				effectId: 0,
				checksum: "25ff451b19677ee75cce1a9520aef30e",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46335&size=130",
				},
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46336,
				cateId: 11962,
				type: 7,
				text: "[^11962.46336^]",
				uri: "46336",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46336&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46336&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 100,
				effectId: 0,
				checksum: "97ef3854a967316c2c3943a12e5ad4e7",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46337,
				cateId: 11962,
				type: 7,
				text: "[^11962.46337^]",
				uri: "46337",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46337&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46337&size=130",
				stickerWebpUrl: null,
				totalFrames: 22,
				duration: 90,
				effectId: 0,
				checksum: "2444547fb8bb3eda65d488f63c135273",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46337&size=130",
				},
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46338,
				cateId: 11962,
				type: 7,
				text: "[^11962.46338^]",
				uri: "46338",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46338&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46338&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "e9ff37eccb0174fa3cfde3815056b31e",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
			{
				id: 46339,
				cateId: 11962,
				type: 7,
				text: "[^11962.46339^]",
				uri: "46339",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46339&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46339&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "860ef123b4322030fa1acd2f6edde8da",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324335,
				updateState: 0,
			},
		],
	},
	{
		id: 10431,
		name: "Mobile Girl, MiM",
		desc: "",
		totalImage: 25,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/5/c/c/3/3/10431/icon/mim_ic.png",
		iconPreview: "https://zalo-api.zadn.vn/5/c/c/3/3/10431/icon_pre/mim_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 3,
		thumbImg: "https://zalo-api.zadn.vn/5/c/c/3/3/10431/preview/mim_cover.png",
		source: "Funnyeve",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 23411,
				cateId: 10431,
				type: 7,
				text: "[^10431.23411^]",
				uri: "23411",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23411&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23411&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "281a38549084eb3a28dd78bc46c84973",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23412,
				cateId: 10431,
				type: 7,
				text: "[^10431.23412^]",
				uri: "23412",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23412&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23412&size=130",
				stickerWebpUrl: null,
				totalFrames: 14,
				duration: 100,
				effectId: 0,
				checksum: "b104e1fbfc05c7ac68626074cd37b189",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23413,
				cateId: 10431,
				type: 7,
				text: "[^10431.23413^]",
				uri: "23413",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23413&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23413&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 100,
				effectId: 0,
				checksum: "481dde9d008b65cd9e87494c1b9bfaf5",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23414,
				cateId: 10431,
				type: 7,
				text: "[^10431.23414^]",
				uri: "23414",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23414&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23414&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 100,
				effectId: 0,
				checksum: "4a723731ccad807506067752c613357e",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=23414&size=130",
				},
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23415,
				cateId: 10431,
				type: 7,
				text: "[^10431.23415^]",
				uri: "23415",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23415&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23415&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "3092c69654c59fddff55d88e4f2a1977",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23416,
				cateId: 10431,
				type: 7,
				text: "[^10431.23416^]",
				uri: "23416",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23416&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23416&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "f7220d2a87a15f567202ffe7048951ec",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23417,
				cateId: 10431,
				type: 7,
				text: "[^10431.23417^]",
				uri: "23417",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23417&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23417&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 100,
				effectId: 0,
				checksum: "367dd8d155b8e7d69dd717278528779f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23418,
				cateId: 10431,
				type: 7,
				text: "[^10431.23418^]",
				uri: "23418",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23418&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23418&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 100,
				effectId: 0,
				checksum: "123bfd7d398ae720f00a05738413422c",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23419,
				cateId: 10431,
				type: 7,
				text: "[^10431.23419^]",
				uri: "23419",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23419&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23419&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 100,
				effectId: 0,
				checksum: "4bb6c65565018d6372a3363d506513c8",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23420,
				cateId: 10431,
				type: 7,
				text: "[^10431.23420^]",
				uri: "23420",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23420&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23420&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 100,
				effectId: 0,
				checksum: "093ec2c6036abf66bad356f88d906feb",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23421,
				cateId: 10431,
				type: 7,
				text: "[^10431.23421^]",
				uri: "23421",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23421&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23421&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "6e9c072e9443b0f5cfe0f7000385a0d0",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23422,
				cateId: 10431,
				type: 7,
				text: "[^10431.23422^]",
				uri: "23422",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23422&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23422&size=130",
				stickerWebpUrl: null,
				totalFrames: 13,
				duration: 100,
				effectId: 0,
				checksum: "0282cc5bfd4864ba13835242f4b54177",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23423,
				cateId: 10431,
				type: 7,
				text: "[^10431.23423^]",
				uri: "23423",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23423&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23423&size=130",
				stickerWebpUrl: null,
				totalFrames: 19,
				duration: 100,
				effectId: 0,
				checksum: "3e66422db9caa7543265f86efb00f610",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23424,
				cateId: 10431,
				type: 7,
				text: "[^10431.23424^]",
				uri: "23424",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23424&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23424&size=130",
				stickerWebpUrl: null,
				totalFrames: 13,
				duration: 100,
				effectId: 0,
				checksum: "432ceaf9c975e9bedb04ada85ddfc5fe",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23425,
				cateId: 10431,
				type: 7,
				text: "[^10431.23425^]",
				uri: "23425",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23425&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23425&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 100,
				effectId: 0,
				checksum: "5db43c5753087bdbd4ba7b24e7b2c91f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23426,
				cateId: 10431,
				type: 7,
				text: "[^10431.23426^]",
				uri: "23426",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23426&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23426&size=130",
				stickerWebpUrl: null,
				totalFrames: 13,
				duration: 100,
				effectId: 0,
				checksum: "88c97dd2c5098c2b824ed42a5b0e1acb",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23427,
				cateId: 10431,
				type: 7,
				text: "[^10431.23427^]",
				uri: "23427",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23427&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23427&size=130",
				stickerWebpUrl: null,
				totalFrames: 5,
				duration: 100,
				effectId: 0,
				checksum: "4908236c5559bd8cb8ee6d8861601ba9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23428,
				cateId: 10431,
				type: 7,
				text: "[^10431.23428^]",
				uri: "23428",
				fkey: 7,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23428&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23428&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 100,
				effectId: 0,
				checksum: "0b2c51ed9580b8e5eafd1db4d40e38e3",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23429,
				cateId: 10431,
				type: 7,
				text: "[^10431.23429^]",
				uri: "23429",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23429&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23429&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "aeb713f8b9223b4646f59eeb14dcfcbc",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23430,
				cateId: 10431,
				type: 7,
				text: "[^10431.23430^]",
				uri: "23430",
				fkey: 8,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23430&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23430&size=130",
				stickerWebpUrl: null,
				totalFrames: 9,
				duration: 100,
				effectId: 0,
				checksum: "6021d57b48ab16245174f0bd1e663dbb",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23431,
				cateId: 10431,
				type: 7,
				text: "[^10431.23431^]",
				uri: "23431",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23431&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23431&size=130",
				stickerWebpUrl: null,
				totalFrames: 13,
				duration: 100,
				effectId: 0,
				checksum: "7c9e333b5ef74129131521fa18331e57",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23432,
				cateId: 10431,
				type: 7,
				text: "[^10431.23432^]",
				uri: "23432",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23432&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23432&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "7dba0fad436d8d71fb3b7571ecaee599",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23433,
				cateId: 10431,
				type: 7,
				text: "[^10431.23433^]",
				uri: "23433",
				fkey: 10,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23433&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23433&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 100,
				effectId: 0,
				checksum: "2843d9ac51a46fa26e9ad989ea915cc7",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23434,
				cateId: 10431,
				type: 7,
				text: "[^10431.23434^]",
				uri: "23434",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23434&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23434&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 100,
				effectId: 0,
				checksum: "e78114e94260c0fee906304c91279a19",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
			{
				id: 23435,
				cateId: 10431,
				type: 7,
				text: "[^10431.23435^]",
				uri: "23435",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23435&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23435&size=130",
				stickerWebpUrl: null,
				totalFrames: 6,
				duration: 100,
				effectId: 0,
				checksum: "9ba9d36cebd5f51a356c7890683d2cfd",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311324171,
				updateState: 0,
			},
		],
	},
	{
		id: 10610,
		name: "Ogu Mỏ Vịt",
		desc: "",
		totalImage: 20,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/5/b/7/0/8/10610/icon/movit_ic.png",
		iconPreview: "https://zalo-api.zadn.vn/5/b/7/0/8/10610/icon_pre/movit_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 4,
		thumbImg: "https://zalo-api.zadn.vn/5/b/7/0/8/10610/preview/movit_cover.png",
		source: "Mojitok",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 25708,
				cateId: 10610,
				type: 7,
				text: "[^10610.25708^]",
				uri: "25708",
				fkey: 15,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25708&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25708&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 100,
				effectId: 0,
				checksum: "1adf9e2a56d038bd5301d1ba0ae1a830",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25708&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25709,
				cateId: 10610,
				type: 7,
				text: "[^10610.25709^]",
				uri: "25709",
				fkey: 11,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25709&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25709&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 100,
				effectId: 0,
				checksum: "1e068226437f00130a148613058b8044",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25709&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25710,
				cateId: 10610,
				type: 7,
				text: "[^10610.25710^]",
				uri: "25710",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25710&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25710&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 100,
				effectId: 0,
				checksum: "6177f77a7f90b447de4fdeafc290a7d9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25710&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25711,
				cateId: 10610,
				type: 7,
				text: "[^10610.25711^]",
				uri: "25711",
				fkey: 11,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25711&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25711&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 100,
				effectId: 0,
				checksum: "036d5bd34e0c1a353eef1f5948fb96b3",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25711&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25712,
				cateId: 10610,
				type: 7,
				text: "[^10610.25712^]",
				uri: "25712",
				fkey: 14,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25712&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25712&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "2d85247268579fca21825c8d6576ade5",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25712&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25713,
				cateId: 10610,
				type: 7,
				text: "[^10610.25713^]",
				uri: "25713",
				fkey: 13,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25713&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25713&size=130",
				stickerWebpUrl: null,
				totalFrames: 14,
				duration: 100,
				effectId: 0,
				checksum: "0e0802deb4235356bc541eb1a99a0f8c",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25713&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25714,
				cateId: 10610,
				type: 7,
				text: "[^10610.25714^]",
				uri: "25714",
				fkey: 9,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25714&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25714&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "f76116ac6b2e095b780dbcaf209ecbb5",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25714&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25715,
				cateId: 10610,
				type: 7,
				text: "[^10610.25715^]",
				uri: "25715",
				fkey: 14,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25715&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25715&size=130",
				stickerWebpUrl: null,
				totalFrames: 15,
				duration: 100,
				effectId: 0,
				checksum: "b0bdb63f55893199d3d06644e64c1ef3",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25715&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25716,
				cateId: 10610,
				type: 7,
				text: "[^10610.25716^]",
				uri: "25716",
				fkey: 13,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25716&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25716&size=130",
				stickerWebpUrl: null,
				totalFrames: 14,
				duration: 100,
				effectId: 0,
				checksum: "dae4b294732b9b840727439ff8f3cf6d",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25716&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25717,
				cateId: 10610,
				type: 7,
				text: "[^10610.25717^]",
				uri: "25717",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25717&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25717&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 100,
				effectId: 0,
				checksum: "1739d45414bde4e8244f501ae07a0ee7",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25717&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25718,
				cateId: 10610,
				type: 7,
				text: "[^10610.25718^]",
				uri: "25718",
				fkey: 13,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25718&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25718&size=130",
				stickerWebpUrl: null,
				totalFrames: 14,
				duration: 100,
				effectId: 0,
				checksum: "8aa7ff1b09896c639af992fa1f81a181",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25718&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25719,
				cateId: 10610,
				type: 7,
				text: "[^10610.25719^]",
				uri: "25719",
				fkey: 19,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25719&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25719&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 100,
				effectId: 0,
				checksum: "21f1822306bd47f9a484f7463438d5e5",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25719&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25720,
				cateId: 10610,
				type: 7,
				text: "[^10610.25720^]",
				uri: "25720",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25720&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25720&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "87961b126e029d81b16bdfc9a241e1ef",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25720&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25721,
				cateId: 10610,
				type: 7,
				text: "[^10610.25721^]",
				uri: "25721",
				fkey: 11,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25721&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25721&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 100,
				effectId: 0,
				checksum: "33a9bb200323e1fff6bcf5218e3d4be1",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25721&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25722,
				cateId: 10610,
				type: 7,
				text: "[^10610.25722^]",
				uri: "25722",
				fkey: 12,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25722&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25722&size=130",
				stickerWebpUrl: null,
				totalFrames: 13,
				duration: 100,
				effectId: 0,
				checksum: "3b76ee3944e4159a2a3935ab63de8eda",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25722&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25723,
				cateId: 10610,
				type: 7,
				text: "[^10610.25723^]",
				uri: "25723",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25723&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25723&size=130",
				stickerWebpUrl: null,
				totalFrames: 8,
				duration: 100,
				effectId: 0,
				checksum: "8f8731cafb8191b5b219176d63731b68",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25723&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25724,
				cateId: 10610,
				type: 7,
				text: "[^10610.25724^]",
				uri: "25724",
				fkey: 11,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25724&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25724&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 100,
				effectId: 0,
				checksum: "011585aac60f5441ba3215866bca71dc",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25724&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25725,
				cateId: 10610,
				type: 7,
				text: "[^10610.25725^]",
				uri: "25725",
				fkey: 7,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25725&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25725&size=130",
				stickerWebpUrl: null,
				totalFrames: 22,
				duration: 100,
				effectId: 0,
				checksum: "4363c937e4df45494ffa45da4c5a802b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25725&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25726,
				cateId: 10610,
				type: 7,
				text: "[^10610.25726^]",
				uri: "25726",
				fkey: 9,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25726&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25726&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 100,
				effectId: 0,
				checksum: "6443b4155c4fa8bba6dfb990386c7268",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25726&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
			{
				id: 25727,
				cateId: 10610,
				type: 7,
				text: "[^10610.25727^]",
				uri: "25727",
				fkey: 13,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=25727&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=25727&size=130",
				stickerWebpUrl: null,
				totalFrames: 22,
				duration: 100,
				effectId: 0,
				checksum: "dbbfe3a67aad4d88f7fa49aaeb4ae405",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 3,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=25727&size=130",
				},
				fetchTs: 1745311324991,
				updateState: 0,
			},
		],
	},
	{
		id: 11954,
		name: "Usagyuuun Tăng Động 2",
		desc: "",
		totalImage: 24,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/2/f/2/7/b/11954/icon/usagyuuuntangdong2_icon.png",
		iconPreview:
			"https://zalo-api.zadn.vn/2/f/2/7/b/11954/icon_pre/usagyuuuntangdong2_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 2,
		thumbImg: "https://zalo-api.zadn.vn/2/f/2/7/b/11954/preview/440x440.png",
		source: "Minto Inc.",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 46177,
				cateId: 11954,
				type: 7,
				text: "[^11954.46177^]",
				uri: "46177",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46177&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46177&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 80,
				effectId: 0,
				checksum: "ac2a3cfcf2f8ec31923805a69846b256",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46177&size=130",
				},
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46178,
				cateId: 11954,
				type: 7,
				text: "[^11954.46178^]",
				uri: "46178",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46178&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46178&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "614074441df470208b9d5e1b1e457c33",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46179,
				cateId: 11954,
				type: 7,
				text: "[^11954.46179^]",
				uri: "46179",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46179&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46179&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "acbe8cfad7ce69bbd7114c37d2469fe6",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46180,
				cateId: 11954,
				type: 7,
				text: "[^11954.46180^]",
				uri: "46180",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46180&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46180&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "4df5eb2817dcdd6f56888eaf4a0b607c",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46181,
				cateId: 11954,
				type: 7,
				text: "[^11954.46181^]",
				uri: "46181",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46181&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46181&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 80,
				effectId: 0,
				checksum: "1ed70ab64de279fd9825b7bdd80a37da",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46181&size=130",
				},
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46182,
				cateId: 11954,
				type: 7,
				text: "[^11954.46182^]",
				uri: "46182",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46182&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46182&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "e049d750a69251bbc2f1cb2f6bef107c",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46183,
				cateId: 11954,
				type: 7,
				text: "[^11954.46183^]",
				uri: "46183",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46183&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46183&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "f51de2942f61dae6ade4dfb89efafbb5",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46184,
				cateId: 11954,
				type: 7,
				text: "[^11954.46184^]",
				uri: "46184",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46184&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46184&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "ad5ac2b1e08960f5b1d23f3e7f2d98e9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46185,
				cateId: 11954,
				type: 7,
				text: "[^11954.46185^]",
				uri: "46185",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46185&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46185&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "972e017e2df83221fcf3f2a48db9a576",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46186,
				cateId: 11954,
				type: 7,
				text: "[^11954.46186^]",
				uri: "46186",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46186&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46186&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "5a609513f6294a6e5e1d503bb637cd3a",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46187,
				cateId: 11954,
				type: 7,
				text: "[^11954.46187^]",
				uri: "46187",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46187&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46187&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "a7bf4e7887e3fc2ce22030aa0a88e41e",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46188,
				cateId: 11954,
				type: 7,
				text: "[^11954.46188^]",
				uri: "46188",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46188&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46188&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "e8a8d3ae34ad18c254a9a7dfcc1c2c6c",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46189,
				cateId: 11954,
				type: 7,
				text: "[^11954.46189^]",
				uri: "46189",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46189&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46189&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "29390c661b82e9bfe272f963d1b06141",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46190,
				cateId: 11954,
				type: 7,
				text: "[^11954.46190^]",
				uri: "46190",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46190&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46190&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "9b895194712248ce1bc5b15c84028117",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46191,
				cateId: 11954,
				type: 7,
				text: "[^11954.46191^]",
				uri: "46191",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46191&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46191&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "69a98599e762869fef45566ddc1719ad",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46192,
				cateId: 11954,
				type: 7,
				text: "[^11954.46192^]",
				uri: "46192",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46192&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46192&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "fb3b2692c2e407d2c4bea8bfcf24ce10",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46193,
				cateId: 11954,
				type: 7,
				text: "[^11954.46193^]",
				uri: "46193",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46193&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46193&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "06a53b58d1fea1ee31f244bdf9529db9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46194,
				cateId: 11954,
				type: 7,
				text: "[^11954.46194^]",
				uri: "46194",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46194&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46194&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "83de1c43813a6c25a86ecc7cca271d06",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46195,
				cateId: 11954,
				type: 7,
				text: "[^11954.46195^]",
				uri: "46195",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46195&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46195&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "0e03895d39fce56c9245e91947a12540",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46196,
				cateId: 11954,
				type: 7,
				text: "[^11954.46196^]",
				uri: "46196",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46196&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46196&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "9dcad7ae62d6373f1b0e0bbf3c20add1",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46197,
				cateId: 11954,
				type: 7,
				text: "[^11954.46197^]",
				uri: "46197",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46197&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46197&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "9fad9f2d30d45256b3ff3e67ef67a40b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46198,
				cateId: 11954,
				type: 7,
				text: "[^11954.46198^]",
				uri: "46198",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46198&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46198&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 60,
				effectId: 0,
				checksum: "f7d61c261e7a05ededb99cb6a00eabcb",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 1,
				extInfo: {
					customUrl:
						"http://zalo-api.zadn.vn/api/emoticon/sticker/custom/file?eid=46198&size=130",
				},
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46199,
				cateId: 11954,
				type: 7,
				text: "[^11954.46199^]",
				uri: "46199",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46199&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46199&size=130",
				stickerWebpUrl: null,
				totalFrames: 20,
				duration: 70,
				effectId: 0,
				checksum: "87e6150699423a26257325e4a08b0023",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
			{
				id: 46200,
				cateId: 11954,
				type: 7,
				text: "[^11954.46200^]",
				uri: "46200",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=46200&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=46200&size=130",
				stickerWebpUrl: null,
				totalFrames: 18,
				duration: 70,
				effectId: 0,
				checksum: "1172538353d6a4b44ae23a342a9c6233",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745312830081,
				updateState: 0,
			},
		],
	},
	{
		id: 10398,
		name: "Tonton Friends",
		desc: "",
		totalImage: 20,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/f/6/c/1/5/10398/icon/tonton_ic.png",
		iconPreview: "https://zalo-api.zadn.vn/f/6/c/1/5/10398/icon_pre/tonton_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 3,
		thumbImg: "https://zalo-api.zadn.vn/f/6/c/1/5/10398/preview/tonton_cover.png",
		source: "Tonton House Co., Ltd.",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 23037,
				cateId: 10398,
				type: 7,
				text: "[^10398.23037^]",
				uri: "23037",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23037&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23037&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23038,
				cateId: 10398,
				type: 7,
				text: "[^10398.23038^]",
				uri: "23038",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23038&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23038&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23039,
				cateId: 10398,
				type: 7,
				text: "[^10398.23039^]",
				uri: "23039",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23039&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23039&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23040,
				cateId: 10398,
				type: 7,
				text: "[^10398.23040^]",
				uri: "23040",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23040&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23040&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23041,
				cateId: 10398,
				type: 7,
				text: "[^10398.23041^]",
				uri: "23041",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23041&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23041&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23042,
				cateId: 10398,
				type: 7,
				text: "[^10398.23042^]",
				uri: "23042",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23042&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23042&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23043,
				cateId: 10398,
				type: 7,
				text: "[^10398.23043^]",
				uri: "23043",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23043&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23043&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23044,
				cateId: 10398,
				type: 7,
				text: "[^10398.23044^]",
				uri: "23044",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23044&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23044&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23045,
				cateId: 10398,
				type: 7,
				text: "[^10398.23045^]",
				uri: "23045",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23045&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23045&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23046,
				cateId: 10398,
				type: 7,
				text: "[^10398.23046^]",
				uri: "23046",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23046&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23046&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23047,
				cateId: 10398,
				type: 7,
				text: "[^10398.23047^]",
				uri: "23047",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23047&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23047&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23048,
				cateId: 10398,
				type: 7,
				text: "[^10398.23048^]",
				uri: "23048",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23048&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23048&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23049,
				cateId: 10398,
				type: 7,
				text: "[^10398.23049^]",
				uri: "23049",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23049&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23049&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23050,
				cateId: 10398,
				type: 7,
				text: "[^10398.23050^]",
				uri: "23050",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23050&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23050&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23051,
				cateId: 10398,
				type: 7,
				text: "[^10398.23051^]",
				uri: "23051",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23051&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23051&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23052,
				cateId: 10398,
				type: 7,
				text: "[^10398.23052^]",
				uri: "23052",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23052&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23052&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23053,
				cateId: 10398,
				type: 7,
				text: "[^10398.23053^]",
				uri: "23053",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23053&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23053&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23054,
				cateId: 10398,
				type: 7,
				text: "[^10398.23054^]",
				uri: "23054",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23054&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23054&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23055,
				cateId: 10398,
				type: 7,
				text: "[^10398.23055^]",
				uri: "23055",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23055&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23055&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
			{
				id: 23056,
				cateId: 10398,
				type: 7,
				text: "[^10398.23056^]",
				uri: "23056",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=23056&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=23056&size=130",
				stickerWebpUrl: null,
				totalFrames: 0,
				duration: 300,
				effectId: 0,
				checksum: "",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745311325313,
				updateState: 0,
			},
		],
	},
	{
		id: 12616,
		name: "Cà Méo Ngáo Ngơ",
		desc: "",
		totalImage: 16,
		thumbUrl: "",
		iconUrl: "https://zalo-api.zadn.vn/d/1/9/a/c/12616/icon/cameongaongo_icon.png",
		iconPreview: "https://zalo-api.zadn.vn/d/1/9/a/c/12616/icon_pre/cameongaongo_thumb.png",
		price: -1,
		group: 2,
		status: 0,
		version: 2,
		thumbImg: "https://zalo-api.zadn.vn/d/1/9/a/c/12616/preview/440x440.png",
		source: "MediaZ",
		type: 1,
		sourceUrl: "",
		permission: 1,
		expireTime: 0,
		is_hidden: 0,
		order: 0,
		stickers: [
			{
				id: 50506,
				cateId: 12616,
				type: 7,
				text: "[^12616.50506^]",
				uri: "50506",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50506&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50506&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 60,
				effectId: 0,
				checksum: "a6690cf835fdc57c862dd6d08ecda2bf",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50507,
				cateId: 12616,
				type: 7,
				text: "[^12616.50507^]",
				uri: "50507",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50507&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50507&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "a8ae27febb85998ec899690355075f6b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50508,
				cateId: 12616,
				type: 7,
				text: "[^12616.50508^]",
				uri: "50508",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50508&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50508&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "a345088c9246d15e6f8b53a4780c20a5",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50509,
				cateId: 12616,
				type: 7,
				text: "[^12616.50509^]",
				uri: "50509",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50509&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50509&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "9dea8961b10bf1dd77bb9d043963a08a",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50510,
				cateId: 12616,
				type: 7,
				text: "[^12616.50510^]",
				uri: "50510",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50510&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50510&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "3f519e41c0d3d0748be13db9b138efa0",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50511,
				cateId: 12616,
				type: 7,
				text: "[^12616.50511^]",
				uri: "50511",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50511&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50511&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "67d2980bd65018b3589c5f57f7b46d26",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50512,
				cateId: 12616,
				type: 7,
				text: "[^12616.50512^]",
				uri: "50512",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50512&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50512&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "c2f3e968b7c55095617bbdf1401c737c",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50513,
				cateId: 12616,
				type: 7,
				text: "[^12616.50513^]",
				uri: "50513",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50513&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50513&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 60,
				effectId: 0,
				checksum: "e289a7c1081b093722e1e8f40b8cc7d7",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50514,
				cateId: 12616,
				type: 7,
				text: "[^12616.50514^]",
				uri: "50514",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50514&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50514&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "1fbc39dc81843884e74b1e9ba5513a9b",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50515,
				cateId: 12616,
				type: 7,
				text: "[^12616.50515^]",
				uri: "50515",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50515&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50515&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 60,
				effectId: 0,
				checksum: "a4444541e7add5ff8784dd1826369106",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50516,
				cateId: 12616,
				type: 7,
				text: "[^12616.50516^]",
				uri: "50516",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50516&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50516&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "1dc8bc6135240f3c70ac240e337bb4db",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50517,
				cateId: 12616,
				type: 7,
				text: "[^12616.50517^]",
				uri: "50517",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50517&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50517&size=130",
				stickerWebpUrl: null,
				totalFrames: 16,
				duration: 60,
				effectId: 0,
				checksum: "a81b38d6b4633df7ebfa156d84aca808",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50518,
				cateId: 12616,
				type: 7,
				text: "[^12616.50518^]",
				uri: "50518",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50518&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50518&size=130",
				stickerWebpUrl: null,
				totalFrames: 11,
				duration: 60,
				effectId: 0,
				checksum: "f43aa724144788559c6e143a99db9e8f",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50519,
				cateId: 12616,
				type: 7,
				text: "[^12616.50519^]",
				uri: "50519",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50519&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50519&size=130",
				stickerWebpUrl: null,
				totalFrames: 10,
				duration: 60,
				effectId: 0,
				checksum: "a20fb2bda1ce798b055fb9cba44e2483",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50520,
				cateId: 12616,
				type: 7,
				text: "[^12616.50520^]",
				uri: "50520",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50520&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50520&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "d7be5b9d395dd589ef4c27cf0ac41d7a",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
			{
				id: 50521,
				cateId: 12616,
				type: 7,
				text: "[^12616.50521^]",
				uri: "50521",
				fkey: 0,
				status: 0,
				stickerUrl:
					"https://zalo-api.zadn.vn/api/emoticon/sticker/webpc?eid=50521&size=130",
				stickerSpriteUrl: "https://zalo-api.zadn.vn/api/emoticon/sprite?eid=50521&size=130",
				stickerWebpUrl: null,
				totalFrames: 12,
				duration: 60,
				effectId: 0,
				checksum: "f6691dcb55b0e909644a8f5376d880a9",
				ext: 0,
				source: 0,
				fss: null,
				fssInfo: null,
				version: 0,
				extInfo: null,
				fetchTs: 1745400492378,
				updateState: 0,
			},
		],
	},
];
